define('drops/drawings/gateway/gateway',['jquery', 'drops/drawings/businessprocessElement'],
    function ($, BusinessProcessElement) {
    'use strict';

    Gateway.EXLUSIVE = "exclusive";
    Gateway.PARALLEL = "parallel";

    var defaults = {
        data: {
            size: { x: 40, y: 40 },
            text: '',
            gateType: Gateway.EXLUSIVE,
            textPosition: 'Right',
            linkToApplication: false
        }
    };

    function Gateway(options) {
        BusinessProcessElement.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.$text = self.createTextElement();
        self.$textCell = $('<div/>')
            .append(self.$text)
            .addClass('bp-textcell');
        self.$textContainer = $('<div/>')
            .append(self.$textCell)
            .addClass('bp-textcontainer');

        self.$text.addClass('bp-text-' + self.data.textPosition);
        self.$textCell.addClass('bp-textcell-' + self.data.textPosition);
        self.$textContainer.addClass('bp-textcontainer-' + self.data.textPosition);

        var $diamond = $('<div/>')
            .addClass('bp-gateway-diamond')
            .addClass('bp-element');

        self.$plusSign = $('<div/>')
            .addClass('bp-gateway-plus')
            .hide();

        self.$element
	        .addClass('boxToBorderSize')
            .addClass('bp-gateway')
            .append($diamond)
            .append(self.$textContainer)
            .append(self.$plusSign);

        if (self.data.gateType === Gateway.PARALLEL) {
            self.$plusSign.show();
        }
    };

    BusinessProcessElement.extend(Gateway, BusinessProcessElement);

    Gateway.typeName = 'Gateway';

    Gateway.prototype.preRender = function () {
        if (!this.editable && this.data.entityId) {
            var self = this;
            this.$element
                .css('cursor', 'pointer')
                .on('click', function () {
                    self.triggerEvent('drawingClicked', self.data.entityId);
                });
        }

        this.applyPosition();
    };

    Gateway.prototype.createTextElement = function () {
        return $('<div/>')
            .text(this.data.text)
            .addClass('bp-text');
    };

    return Gateway;
});
